import React, { useEffect, useState } from 'react';
import './ThankYouContainer.css';
import { money } from '../../helper/Utility'
import { useTranslation } from 'react-i18next';
import { Divider, Paper } from '@material-ui/core';

const ThankYouSummary = ({ order, cart }) => {
  const { t, i18n } = useTranslation();
  const pickupSrc = process.env.PUBLIC_URL + '/Pickup.png';
  const deliverySrc = process.env.PUBLIC_URL + '/DeliveryTruck.png';
  //Variables for scheduled pickup/delivery
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const deliveryDate = new Date(cart.delivery.date).toLocaleDateString(undefined, options).slice(0, -5);
  const deliveryArray = deliveryDate.split(" ");
  const day = deliveryArray[0].slice(0, -1);
  deliveryArray.push(day);

  useEffect(() => {
    setScheduleDate(deliveryArray);
    setScheduleTime(cart.delivery.time_window_code)
  }, [cart])


  return (
    <Paper style={{
      marginBottom: '2rem',
      boxShadow: "0px 0px 1px -1px rgb(0 0 0 / 20%), 0px 0px 1px 0px rgb(0 0 0 / 14%), 0px 0px 3px 0px rgb(0 0 0 / 12%)",
      borderRadius: "4px 4px 0px 0px"
    }}>
      <div className="ThankYouComponent">
        <h3>Order summary {order.name}</h3>
        <Divider variant="fullWidth" style={{ width: '100%', marginTop: 2 }} />
        <div className="ThankYouSummary">
          <img
            className="SummaryIcon"
            src={order.delivery_type === 'pickup' ?
              pickupSrc : deliverySrc}
            alt="Pickup/Delivery"
          />
          <div style={{ textAlign: 'center' }}>
            <p className="SummarySchedule">{order.delivery_type === 'pickup' ? t("Ready for pickup") : t('Should arrive')}:</p>
            <p>{t(scheduleDate[3])}, {t(scheduleDate[2])} {scheduleDate[1]}</p>
            <p>{t("between")} {scheduleTime}</p>
          </div>
        </div>
        <Divider variant="fullWidth" style={{ width: '100%', marginTop: 2 }} />
        <table className="TotalsTable">
          <tbody>
            <tr>
              <td className="paymentInfo">{t("Subtotal")}</td>
              <td className="paymentValue" align="right">{money(order.sold_subtotal_price)}</td>
            </tr>
            {cart.total_bottle_deposit === 0 ? "" :
              <tr>
                <td className="paymentInfo">{t("Bottle Deposit")}</td>
                <td className="paymentValue" align="right">{money(cart.total_bottle_deposit)}</td>
              </tr>}
            <tr>
              <td className="paymentInfo">{t("Shipping")}</td>
              <td className="paymentValue" align="right">{money(cart.total_shipping_fee)}</td>
            </tr>
            {cart.total_extra_charge > 0 ?
              <tr>
                <td className="paymentInfo">{t("Estimated adjustment (+10%)")}</td>
                <td className="paymentValue" align="right">{money(cart.total_extra_charge)}</td>
              </tr> : null
            }
            {cart.total_discounts > 0 ?
              <tr>
                <td className="paymentInfo">{t("Total discounts")}</td>
                <td className="paymentValue" align="right">{`-${money(cart.total_discounts)}`}</td>
              </tr> : null
            }
            <tr>
              <td className="paymentInfo">{t("Tax")}</td>
              <td className="paymentValue" align="right">{'$' + (Number(cart.total_tax || 0) / 100).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        <Divider variant="fullWidth" style={{ width: '100%', marginTop: 2 }} />

        <table className="TotalsTable">
          <tbody>
            <tr>
              <td className="paymentInfoTotal">{t("Total")}</td>
              <td className="paymentTotal" align="right">{money(cart.total_price)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <img src={process.env.PUBLIC_URL + '/Border.png'} alt="" className="SummaryBorder" />
    </Paper>
  )
}

export default ThankYouSummary